//:::::::::::::::::::::::::
import css from './list.module.css'
//:::::::::::::::::::::::::

export default function List(props: { children: React.ReactNode }) {
  return <ul className={css.list}>{props.children}</ul>
}
